import { createAction, props } from "@ngrx/store";
import { Settings } from "src/model/class/settings";
import { ServerSettingsStoreAction } from "src/components/shared-components/enum/enumStoreAction";

/**
 * Server settings unset state and update storage key
 */
export const serverSettingsUnsetKeyStorageAction = createAction(
  ServerSettingsStoreAction.SERVER_SETTINGS_UNSET_KEY_STORAGE
);

/**
 * Server serttings complete action
 */
export const serverSettingsLoadCompleteAction = createAction(
  ServerSettingsStoreAction.SERVER_SETTINGS_LOAD_COMPLETE,
  props<{ serverSettings: Settings }>()
);

/**
 * SServer setting update status bar
 */
export const serverSettingsUpdateShowStatusBarAction = createAction(
  ServerSettingsStoreAction.SERVER_SETTINGS_UPDATE_SHOW_STATUS_BAR,
  props<{ showStatusbar: boolean }>()
);
